<template>
<div class="modal fade" id="modalWorkshiftTimezoneBulk" role="dialog">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="title-modal">Alterar fuso em massa</h4>
        <p class="subtitle-modal">
          Selecione os turnos abaixo, escolha o novo fuso e (opcionalmente)
          aplique também na configuração da empresa.
        </p>
      </div>

      <div class="modal-body">
        <div v-if="loadingModal" class="loading center_vertical">
          <div class="loader-mini-box">
            <div class="spinner-box">
              <div class="rect1"></div><div class="rect2"></div>
              <div class="rect3"></div><div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </div>
        </div>

        <div v-if="!loadingModal">
          <!-- Fuso atual da empresa -->
          <div class="info-line">
            <strong>{{ labels.companySettings.defaultTimeZone }}:</strong>
            <span>{{ helpers.formatTimezoneFriendly(companyTimeZone, timezones) }}</span>
          </div>

          <!-- Novo fuso -->
          <div class="form-group">
            <label>Novo fuso horário</label>
            <select v-model="gmtHour" class="form-control">
              <option value="">Selecione o fuso (GMT)</option>
              <option v-for="(label, key) in timezones" :key="key" :value="key">{{ label }}</option>
            </select>
          </div>

          <!-- Aplicar também na empresa -->
          <div class="form-group checkbox-line">
            <label>
              <input type="checkbox" v-model="alsoApplyToCompanySettings" />
              Aplicar também no fuso padrão da empresa
            </label>
          </div>

          <!-- Lista de turnos -->
          <label class="lbl-section">
            Turnos
            <span class="select-all">
              <input type="checkbox" :checked="allSelected" @change="toggleAll($event.target.checked)" />
              Selecionar todos
            </span>
          </label>

          <div v-if="!workshifts.length" class="empty">Nenhum turno encontrado.</div>

          <div v-else>
            <div class="workshift-search">
              <input type="text" v-model="workshiftFilter" placeholder="Buscar turno pelo nome..." />
              <span class="count">{{ filteredWorkshifts.length }} de {{ workshifts.length }} turno(s)</span>
            </div>

            <table class="table-workshifts">
              <thead>
                <tr>
                  <th></th>
                  <th>Turno</th>
                  <th>Tipo</th>
                  <th>{{ labels.workShift.timeZone }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="ws in filteredWorkshifts" :key="ws.id">
                  <td>
                    <input type="checkbox" :value="ws.id" v-model="selectedWorkshifts" />
                  </td>
                  <td>{{ ws.name }}</td>
                  <td>{{ helpers.getWorkShiftTypeLabel(ws.workShiftType) }}</td>
                  <td>{{ helpers.formatInheritableTimezoneFriendly(ws.timeZone, companyTimeZone, timezones) }}</td>
                </tr>
                <tr v-if="!filteredWorkshifts.length">
                  <td :colspan="4" class="empty-row">Nenhum turno encontrado para "{{ workshiftFilter }}".</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-if="errorMessage" class="error-msg">{{ errorMessage }}</div>
      </div>

      <div class="modal-footer">
        <button v-if="!loadingModal" :disabled="!canSave || loadingSave"
                v-bind:class="{'disable': !canSave || loadingSave}"
                class="btn btn-register" v-on:click="save()">
          <span v-if="!loadingSave">Aplicar fuso</span>
          <div class="loading-btn" v-else>
            <div class="spinner-btn">
              <div class="rect1"></div><div class="rect2"></div>
              <div class="rect3"></div><div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </div>
        </button>
        <button v-on:click="closeModal()" class="close-btn">Fechar</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {
  UPDATE_WORKSHIFT_TIMEZONE_BULK,
  GET_WORKSHIFT_FULL_VIEW,
  GET_TIMEZONE_LIST
} from "../../../urlConfig";
import { REQUEST_SERVICE } from "../../../requestConfig";
import { UTIL_SERVICE } from "../../../utils";
import {
  workShiftLabels,
  companySettingsLabels,
  labelHelpers
} from "../../../labels/workshiftLabels";
import swal from "sweetalert";

export default {
  name: "modalWorkshiftTimezoneBulk",
  props: ["dataCompanyModal"],
  data() {
    return {
      loadingModal: false,
      loadingSave: false,
      modalContext: "",
      companyId: "",
      companyTimeZone: "",
      gmtHour: "",
      alsoApplyToCompanySettings: false,
      timezones: {},
      workshifts: [],
      selectedWorkshifts: [],
      workshiftFilter: "",
      errorMessage: "",
      labels: {
        workShift: workShiftLabels,
        companySettings: companySettingsLabels
      },
      helpers: labelHelpers
    };
  },
  computed: {
    filteredWorkshifts() {
      const q = (this.workshiftFilter || "").trim().toLowerCase();
      if (!q) return this.workshifts;
      return this.workshifts.filter((w) => (w.name || "").toLowerCase().indexOf(q) !== -1);
    },
    allSelected() {
      const list = this.filteredWorkshifts;
      if (!list.length) return false;
      return list.every((w) => this.selectedWorkshifts.indexOf(w.id) !== -1);
    },
    canSave() {
      return !!this.gmtHour && (this.selectedWorkshifts.length > 0 || this.alsoApplyToCompanySettings);
    }
  },
  watch: {
    dataCompanyModal(val) {
      if (!val) return;
      this.modalContext = val.context;
      this.companyId = val.companyId || (this.$route && this.$route.params.idCompany);
      this.errorMessage = "";
      this.gmtHour = "";
      this.alsoApplyToCompanySettings = false;
      this.selectedWorkshifts = [];
      this.loadAll();
    }
  },
  methods: {
    loadAll() {
      this.loadingModal = true;
      Promise.all([this.loadTimezones(), this.loadWorkshifts()])
        .then(() => { this.loadingModal = false; })
        .catch(() => { this.loadingModal = false; });
    },
    loadTimezones() {
      return REQUEST_SERVICE.get(GET_TIMEZONE_LIST).then((response) => {
        this.timezones = response.data || {};
      }).catch(() => {
        this.timezones = {};
      });
    },
    loadWorkshifts() {
      return REQUEST_SERVICE.requestContext(
        "GET",
        `${GET_WORKSHIFT_FULL_VIEW}?companyId=${this.companyId}`,
        this.modalContext
      ).then((response) => {
          const data = response.data || {};
          this.companyTimeZone = data.defaultTimeZone || "";
          this.workshifts = Array.isArray(data.workshifts) ? data.workshifts : [];
          this.workshiftFilter = "";
        })
        .catch(() => {
          this.workshifts = [];
          this.errorMessage = "Falha ao carregar turnos. Verifique a empresa.";
        });
    },
    toggleAll(checked) {
      const filteredIds = this.filteredWorkshifts.map((w) => w.id);
      if (checked) {
        const set = {};
        this.selectedWorkshifts.forEach((id) => { set[id] = true; });
        filteredIds.forEach((id) => { set[id] = true; });
        this.selectedWorkshifts = Object.keys(set);
      } else {
        const remove = {};
        filteredIds.forEach((id) => { remove[id] = true; });
        this.selectedWorkshifts = this.selectedWorkshifts.filter((id) => !remove[id]);
      }
    },
    closeModal() {
      $("#modalWorkshiftTimezoneBulk").modal("toggle");
    },
    save() {
      if (this.loadingSave || !this.canSave) return;
      this.loadingSave = true;
      const payload = {
        companyId: this.companyId,
        // O backend (UpdateWorkshiftTimezoneBulk) recebe o nome Windows do
        // fuso (ex.: "E. South America Standard Time"), validado pelo
        // TimeZoneVO.IsAValidTimeZone. Esse é o mesmo formato retornado
        // por GET_TIMEZONE_LIST e usado no GET unitário do support.
        timeZone: this.gmtHour,
        workshiftIds: this.selectedWorkshifts,
        alsoApplyToCompanySettings: this.alsoApplyToCompanySettings
      };

      REQUEST_SERVICE.requestContext("PUT", UPDATE_WORKSHIFT_TIMEZONE_BULK, this.modalContext, payload)
        .then((response) => {
          UTIL_SERVICE.console("RESULT UPDATE_WORKSHIFT_TIMEZONE_BULK:", response);
          this.loadingSave = false;
          $("#modalWorkshiftTimezoneBulk").modal("toggle");
          swal("Sucesso", "Fuso aplicado em massa.", "success");
        })
        .catch(() => {
          this.loadingSave = false;
          swal("Aviso", "Falha ao aplicar fuso em massa. Verifique o GMT e tente novamente.", "error");
        });
    }
  }
};
</script>

<style lang="scss">
#modalWorkshiftTimezoneBulk {
  .modal-header { padding: 15px 15px 0; border-bottom: none; }
  .title-modal {
    text-align: center; padding-top: 10px; font-weight: bold;
    letter-spacing: 1px; text-transform: uppercase;
  }
  .subtitle-modal {
    text-align: center; color: #777; font-size: 13px;
    margin-top: 8px; padding: 0 30px;
  }
  .modal-body { padding: 20px 40px; }

  .info-line {
    margin-bottom: 16px;
    strong { margin-right: 6px; }
  }

  .lbl-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 600;
    margin-top: 16px;
    margin-bottom: 8px;
    color: #333;

    .select-all {
      font-weight: normal;
      font-size: 13px;
      color: #555;
      input { margin-right: 4px; }
    }
  }

  .checkbox-line label {
    display: flex; align-items: center; gap: 8px; font-weight: normal;
  }

  .table-workshifts {
    width: 100%; border-collapse: collapse; font-size: 13px;
    th, td { border-bottom: 1px solid #eee; padding: 8px 6px; text-align: left; }
    th { color: #555; font-weight: 600; }
  }

  .workshift-search {
    display: flex; align-items: center; gap: 10px; margin-bottom: 10px; flex-wrap: wrap;
    input {
      flex: 1 1 260px; min-width: 200px;
      border: 1px solid #ccc; border-radius: 4px; padding: 6px 10px; font-size: 13px;
    }
    .count { font-size: 12px; color: #888; }
  }
  .empty-row { text-align: center; color: #999; padding: 14px; font-style: italic; }

  .empty { text-align: center; color: #999; padding: 30px 0; }
  .error-msg { color: #e74a4e; margin-top: 12px; text-align: center; font-size: 13px; }

  .modal-footer {
    .close-btn {
      border-radius: 4px !important; background-color: #8b8787;
      padding: 7px 35px; font-weight: 600; color: #fff; border: none; height: 36px;
    }
    .btn-register {
      border-radius: 4px !important; background-color: #3598dc;
      padding: 7px 35px; font-weight: 600; color: #fff; border: none; height: 36px;
    }
    .btn-register.disable { opacity: 0.5; cursor: not-allowed; }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalWorkshiftTimezoneBulk.vue